import z from "zod/v4";

export const VenueOnlineConfigSchema = z
  .object({
    uuid: z.string(),
    venueUuid: z.string(),
    allowVouchers: z.boolean().default(false),
    customVoucherAmounts: z.boolean().default(true),
    onlineVoucherSales: z.boolean().default(false),
    minVoucherAmountInCents: z.number().int().min(0).default(0),
    maxVoucherAmountInCents: z.number().int().min(0).default(0),
    hasActiveVouchers: z.boolean().default(false),
  })
  .transform((obj) => ({
    ...obj,
    minVoucherAmount: obj.minVoucherAmountInCents / 100,
    maxVoucherAmount: obj.maxVoucherAmountInCents / 100,
  }));

export type VenueOnlineConfig = z.infer<typeof VenueOnlineConfigSchema>;
